var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvXumoStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80821 8.00002L0.300049 14.7262H4.6047L7.96054 10.6283L10.1128 8.00002H5.80821Z",
    fill: "#05B2B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96054 5.37179L4.6047 1.27391H0.300049L5.80821 8.00002H10.1128L7.96054 5.37179Z",
    fill: "#BB2E76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96069 10.6283L10.113 8.00002L15.6212 14.7262H11.3165L7.96069 10.6283ZM11.3165 1.2739L15.6212 1.2739L10.113 8.00002L7.96069 5.37178L11.3165 1.2739Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvXumoStore);
export default __webpack_public_path__ + "static/media/ctv_xumo_store.95b448f3e0be48881ccc3ad27c7ada72.svg";
export { ForwardRef as ReactComponent };